import React from 'react';
import { Typography, Container } from '@mui/material';
import Header from '../components/global/headers/Header';
import i18next from 'i18next';
import { useTranslation } from 'react-i18next';

const PrivacyPolicy = () => {
    const lng = i18next.language;
    const {t} = useTranslation()
    // المحتوى باللغتين
    const content = {
        ar: {
            title: "سياسة الخصوصية وشروط الاستخدام",
            intro: "يهتم مصنع ميم دورز لصناعة الأبواب الداخلية من نوع WPC بحماية بيانات المستفيدين من خدماتها وأنظمتها، والحفاظ على خصوصيتهم وذلك بتطبيق الضوابط الإدارية والتدابير التقنية اللازمة؛ وفقاً لما ذكر في الأنظمة واللوائح ذات العلاقة.",
            sections: {
                dataCollection: {
                    title: "1.1 ما هي البيانات الشخصية التي يتم جمعها",
                    items: [
                        {
                            title: "بيانات الحساب:",
                            content: "تشمل بيانات الدخول كأسماء المستخدمين وكلمات المرور وبيانات التواصل كأرقام الهواتف والبريد الالكتروني والعنوان الشخصي."
                        },
                        {
                            title: "البيانات التقنية:",
                            content: "بما في ذلك عنوان بروتوكول الإنترنت الخاص بك (IP) الذي يستخدم لربط حاسبك الشخصي بالإنترنت."
                        }
                    ]
                },
                collectionMethods: {
                    title: "1.2 كيف يتم جمع البيانات الشخصية",
                    direct: "الطرق المباشرة:",
                    directItems: [
                        "الخدمات: عند التسجيل في القنوات الرقمية",
                        "التواصل: عند التواصل مع الشركة عبر قنوات خدمة العملاء",
                        "استطلاعات الرأي"
                    ],
                    indirect: "الطرق غير المباشرة:",
                    indirectItems: [
                        "البيانات التي يتم تزويدنا بها عن طريق جهات أخرى",
                        "ملفات تعريف الارتباط (Cookies)"
                    ]
                },
                legalBasis: {
                    title: "1.3 الأساس النظامي لجمع بياناتك الشخصية والغرض من جمعها",
                    items: [
                        "إمكانية تقديم المنتجات عبر الموقع الإلكتروني",
                        "إصدار السياسات وإعداد الدراسات",
                        "حل ومعالجة استفسارات العملاء",
                        "تطوير الخدمات وتحسين تجربة المستخدم",
                        "تلبية المتطلبات القانونية والتنظيمية"
                    ]
                },
                dataSharing: {
                    title: "1.4 مشاركة البيانات الشخصية",
                    items: [
                        "الجهات الخارجية لتحليل استخدام الخدمات (وفق سياساتهم الخاصة)",
                        "الجهات الحكومية لأغراض نظامية أو لتحقيق مصلحة عامة"
                    ]
                },
                contact: {
                    title: "1.5 هل لديك استفسار أو شكوى؟",
                    content: "للإستفسارات أو الشكاوى:",
                    email: "البريد الإلكتروني:",
                    phone: "الهاتف:"
                }
            },
            lastUpdate: "آخر تحديث:"
        },
        en: {
            title: "Privacy Policy and Terms of Use",
            intro: "Mim Doors Factory for WPC interior doors is committed to protecting the data of users of its services and systems, and maintaining their privacy by applying necessary administrative controls and technical measures in accordance with relevant regulations and laws.",
            sections: {
                dataCollection: {
                    title: "1.1 What Personal Data We Collect",
                    items: [
                        {
                            title: "Account Data:",
                            content: "Includes login credentials such as usernames and passwords, and contact information such as phone numbers, email addresses, and physical addresses."
                        },
                        {
                            title: "Technical Data:",
                            content: "Including your IP address used to connect your computer to the internet."
                        }
                    ]
                },
                collectionMethods: {
                    title: "1.2 How We Collect Personal Data",
                    direct: "Direct Methods:",
                    directItems: [
                        "Services: When registering through digital channels",
                        "Communication: When contacting the company through customer service channels",
                        "Surveys"
                    ],
                    indirect: "Indirect Methods:",
                    indirectItems: [
                        "Data provided to us by third parties",
                        "Cookies"
                    ]
                },
                legalBasis: {
                    title: "1.3 Legal Basis for Data Collection",
                    items: [
                        "Providing products through our website",
                        "Developing policies and conducting studies",
                        "Resolving customer inquiries and complaints",
                        "Service development and user experience improvement",
                        "Compliance with legal and regulatory requirements"
                    ]
                },
                dataSharing: {
                    title: "1.4 Data Sharing",
                    items: [
                        "Third parties for service analysis (according to their policies)",
                        "Government entities for legal purposes or public interest"
                    ]
                },
                contact: {
                    title: "1.5 Contact Us",
                    content: "For inquiries or complaints:",
                    email: "Email:",
                    phone: "Phone:"
                }
            },
            lastUpdate: "Last updated:"
        }
    };

    const currentContent = content[lng === 'ar' ? 'ar' : 'en'];

    return (
        <>
            <Header page_name={currentContent.title} />
            <Container
                maxWidth="md"
                sx={{
                    py: 4,
                    direction: lng === 'ar' ? 'rtl' : 'ltr',
                    fontFamily: lng === 'ar' ? "'Noto Sans Arabic', sans-serif" : "'Roboto', sans-serif"
                }}>
                <Typography sx={{
                    lineHeight: { md: 2, xs: 1.8, },
                    fontSize: { md: '1.1rem', xs: 'initial', },
                    wordBreak: 'break-word',
                    overflowWrap: 'break-word',
                    whiteSpace: 'normal',
                    fontWeight: { md: 500, xs: 'initial' }
                }}>
                    {t('pr')}
                </Typography>
                {/* <Box sx={{
                    backgroundColor: '#f8f9fa',
                    p: 3,
                    borderRadius: 2,
                    mb: 4,
                    borderLeft: lng === 'ar' ? '4px solid #2E58A6' : 'none',
                    borderRight: lng === 'en' ? '4px solid #2E58A6' : 'none'
                }}>
                    <Typography variant="body1" sx={{ lineHeight: 2 }}>
                        {currentContent.intro}
                    </Typography>
                </Box>
                <SectionWrapper title={currentContent.sections.dataCollection.title}>
                    {currentContent.sections.dataCollection.items.map((item, index) => (
                        <div key={index}>
                            <Typography component="span" sx={{ fontWeight: 'bold', display: 'block', mb: 1 }}>
                                {item.title}
                            </Typography>
                            <Typography paragraph sx={{ mb: 2 }}>
                                {item.content}
                            </Typography>
                        </div>
                    ))}
                </SectionWrapper>
                <SectionWrapper title={currentContent.sections.collectionMethods.title}>
                    <Typography sx={{ fontWeight: 'bold', mb: 1 }}>
                        {currentContent.sections.collectionMethods.direct}
                    </Typography>
                    {currentContent.sections.collectionMethods.directItems.map((item, index) => (
                        <Typography key={index} paragraph sx={{ mb: 0 }}>
                            • {item}
                        </Typography>
                    ))}

                    <Typography sx={{ fontWeight: 'bold', mt: 2, mb: 1 }}>
                        {currentContent.sections.collectionMethods.indirect}
                    </Typography>
                    {currentContent.sections.collectionMethods.indirectItems.map((item, index) => (
                        <Typography key={index} paragraph sx={{ mb: 0 }}>
                            • {item}
                        </Typography>
                    ))}
                </SectionWrapper>
                <SectionWrapper title={currentContent.sections.legalBasis.title}>
                    {currentContent.sections.legalBasis.items.map((item, index) => (
                        <Typography key={index} paragraph sx={{ mb: 0 }}>
                            • {item}
                        </Typography>
                    ))}
                </SectionWrapper>
                <SectionWrapper title={currentContent.sections.dataSharing.title}>
                    {currentContent.sections.dataSharing.items.map((item, index) => (
                        <Typography key={index} paragraph sx={{ mb: 0 }}>
                            • {item}
                        </Typography>
                    ))}
                </SectionWrapper>
                <Box sx={{
                    backgroundColor: '#1d1f2410',
                    p: 3,
                    borderRadius: 2,
                    mt: 4
                }}>
                    <Typography variant="h5" sx={{ color: 'primary.main', mb: 2 }}>
                        {currentContent.sections.contact.title}
                    </Typography>
                    <Typography paragraph>
                        {currentContent.sections.contact.content}
                        <Box sx={{ mt: 2 }}>
                            {currentContent.sections.contact.email}{' '}
                            <a href="mailto:meemdoors@gmail.com" style={{ color: '#2E58A6', textDecoration: 'none' }}>
                                meemdoors@gmail.com
                            </a>
                        </Box>
                        <Box>
                            {currentContent.sections.contact.phone}{' '}
                            <a href="tel:0550307185" style={{ color: '#2E58A6', textDecoration: 'none' }}>
                                0550307185
                            </a>
                        </Box>
                    </Typography>
                </Box>
                <Box sx={{ textAlign: 'center', mt: 4 }}>
                    <Typography variant="body2">
                        {currentContent.lastUpdate} {new Date().toLocaleDateString(lng === 'ar' ? 'ar-SA' : 'en-US')}
                    </Typography>
                </Box> */}
            </Container>
        </>
    );
};

// Reusable section component
// const SectionWrapper = ({ title, children }) => (
//     <>
//         <Typography variant="h5" sx={{
//             color: 'primary.main',
//             mb: 2,
//             mt: 4,
//             fontWeight: 'bold',
//             fontSize: '1.2rem'
//         }}>
//             {title}
//         </Typography>
//         <Box sx={{
//             backgroundColor: '#ffffff',
//             p: 3,
//             borderRadius: 2,
//             boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//             mb: 4
//         }}>
//             {children}
//         </Box>
//         <Divider sx={{ my: 2 }} />
//     </>
// );

export default PrivacyPolicy;